import Slide from '../components/Slide';
import { customerHome } from '../data/pages';

export default function CustomerHome() {
  const { dataKey, heading, options } = customerHome;
  return <Slide dataKey={dataKey} heading={heading} options={options} />;
}
